import incomeImg from './imgs/income-img.svg';
import offerImg from './imgs/offer-img.svg';
import promImg from './imgs/promotion-img.svg';
import regImg from './imgs/registration-img.svg';
import type { Step } from './types';

export const STEPS: Step[] = [
  {
    id: 1,
    title: 'Регистрируйтесь',
    image: regImg,
  },
  {
    id: 2,
    title: 'Подключайте офферы',
    image: offerImg,
  },
  {
    id: 3,
    title: 'Продвигайте их',
    image: promImg,
  },
  {
    id: 4,
    title: 'Получайте доход',
    image: incomeImg,
  },
];
